import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { getOpenThermStateName, OpenThermSlaveConfigurationFlag, OpenThermVariableName, } from 'openTherm';
import { convertOTFlag, } from 'console/shared/components/dialogs/ot-boiler-state/components/table/type';
import { TableCell, TableRow } from '@mui/material';
import { DisabledTableRow } from 'console/shared/styles/components/table-row';
const convertOTBoilerConfiguration = (value) => [
    convertOTFlag(OpenThermSlaveConfigurationFlag.ct, value, 'Вкл/Выкл', 'Модуляция'),
    ...[
        OpenThermSlaveConfigurationFlag.ch2,
        OpenThermSlaveConfigurationFlag.dhw,
        OpenThermSlaveConfigurationFlag.cc,
    ].map((flag) => convertOTFlag(flag, value, 'Включено', 'Выключено')),
    convertOTFlag(OpenThermSlaveConfigurationFlag.mpf, value, 'Поддерживается', 'Не поддерживается'),
    convertOTFlag(OpenThermSlaveConfigurationFlag.dhwc, value, 'С накопителем', 'Не Проточное'),
];
export function OTBoilerGroup(props) {
    const { ot_value } = props;
    if (ot_value == null) {
        return null;
    }
    const { f } = ot_value;
    return (_jsxs(_Fragment, { children: [_jsx(TableRow, { color: "secondary", children: _jsx(TableCell, { variant: "head", colSpan: 2, align: "center", children: getOpenThermStateName(OpenThermVariableName.sc, 'ru') }) }), convertOTBoilerConfiguration(f).map(({ ot_name, display_value, value }) => (_jsxs(DisabledTableRow, { hover: true, disabled: !value, children: [_jsx(TableCell, { children: ot_name }), _jsx(TableCell, { children: display_value })] }, ot_name)))] }));
}
